export default {

    data(){

        return {

            matchResults      : null,
            selectedProvider  : null
        }
    },
    computed: {

        perfectMatches(){

            if( !this.matchResults ) return [];

            return this.matchResults.filter( result => this.isPerfectScore( result.CompositeScore ) );
        },
        adaptedData(){

            switch( this.upd_api_type ){

                case 'parkinglot':

                    return {

                        'firstName'    : this.parkinglot.provider_first_name,
                        'lastName'     : this.parkinglot.provider_last_name,
                        'addressLine1' : this.parkinglot.provider_address_line1,
                        'zip'          : this.parkinglot.provider_zip,
                        'phone'        : this.parkinglot.provider_phone,
                        'updid'        : this.parkinglot.provider_id
                    }
                case 'profile':

                    return {

                        'firstName'    : this.caregiver.firstname,
                        'lastName'     : this.caregiver.lastname,
                        'addressLine1' : this.caregiver.home_address ? this.caregiver.home_address.address1 : null,
                        'zip'          : this.caregiver.home_address ? this.caregiver.home_address.zip : null,
                        'phone'        : this.caregiver.contact_number ? this.caregiver.contact_number.national_number : null,
                        'updid'        : this.caregiver.upd_id
                    }
                default:

                    return {}
            }
        },
        createProviderAdaptedData(){

            switch( this.upd_api_type ){

                case 'parkinglot':

                    return {

                        'id'           : '',
                        'FirstName'    : '',
                        'LastName'     : '',
                        'AddressLine1' : '',
                        'AddressLine2' : '',
                        'City'         : '',
                        'State'        : '',
                        'Zip'          : '',
                        'CountryCode'  : '',
                        'Phone'        : '',
                        'PhoneExt'     : '',
                        'Email'        : '',
                    }
                case 'profile':

                    return {

                        'id'           : this.caregiver.id,
                        'FirstName'    : this.caregiver.firstname,
                        'LastName'     : this.caregiver.lastname,
                        'AddressLine1' : this.caregiver.home_address ? this.caregiver.home_address.address1 : null,
                        'AddressLine2' : this.caregiver.home_address ? this.caregiver.home_address.address2 : null,
                        'City'         : this.caregiver.home_address ? this.caregiver.home_address.city : null,
                        'State'        : this.caregiver.home_address ? this.caregiver.home_address.state : null,
                        'Zip'          : this.caregiver.home_address ? this.caregiver.home_address.zip : null,
                        'CountryCode'  : this.caregiver.home_address ? this.caregiver.home_address.country : null,
                        'Phone'        : this.caregiver.contact_number ? this.caregiver.contact_number.national_number : null,
                        'PhoneExt'     : this.caregiver.contact_number ? this.caregiver.contact_number.extension : null,
                        'Email'        : this.caregiver.email
                    }
                default:

                    return {}
            }
        },
        updateProviderAdaptedData(){

            switch( this.upd_api_type ){

                case 'parkinglot':

                    return {

                        'id'           : null,
                        'UpdId'        : this.parkinglot.provider_id,
                        'FirstName'    : this.parkinglot.provider_first_name,
                        'LastName'     : this.parkinglot.provider_last_name,
                        'AddressLine1' : this.parkinglot.provider_address_line1,
                        'AddressLine2' : this.parkinglot.provider_address_line2,
                        'City'         : this.parkinglot.provider_city,
                        'State'        : this.parkinglot.provider_state,
                        'Zip'          : this.parkinglot.provider_zip,
                        'CountryCode'  : null,
                        'Phone'        : this.parkinglot.provider_phone,
                        'PhoneExt'     : null,
                        'Email'        : this.parkinglot.provider_email,
                    }
                case 'profile':

                    return {

                        'id'           : this.caregiver.id,
                        'UpdId'        : this.caregiver.upd_id,
                        'FirstName'    : this.caregiver.firstname,
                        'LastName'     : this.caregiver.lastname,
                        'AddressLine1' : this.caregiver.home_address ? this.caregiver.home_address.address1 : null,
                        'AddressLine2' : this.caregiver.home_address ? this.caregiver.home_address.address2 : null,
                        'City'         : this.caregiver.home_address ? this.caregiver.home_address.city : null,
                        'State'        : this.caregiver.home_address ? this.caregiver.home_address.state : null,
                        'Zip'          : this.caregiver.home_address ? this.caregiver.home_address.zip : null,
                        'CountryCode'  : this.caregiver.home_address ? this.caregiver.home_address.country : null,
                        'Phone'        : this.caregiver.contact_number ? this.caregiver.contact_number.national_number : null,
                        'PhoneExt'     : this.caregiver.contact_number ? this.caregiver.contact_number.extension : null,
                        'Email'        : this.caregiver.email
                    }
                default:

                    return {}
            }
        },
    },
    methods: {

        isPerfectScore( score ){ return score == 4; },
        selectProvider( provider ){ this.selectedProvider = provider; },
    }
}